import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  Box,
  styled,
  Typography,
  Button,
  TextField,
  FormHelperText,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import BannerImage from "../professionalTournaments/BannerImage";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const CustomTextarea = styled(TextField)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    color: "black",
    padding: "10px 15px",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    padding: "0",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const BannerForm = ({ formik, edited }) => {
  const bannersCategories = useSelector((state) => state.bannersCategories);

  // "";

  return (
    <Box className="page_inner">
      <form onSubmit={formik.handleSubmit}>
        <Box className="create-banner-form professional-tournament-form">
          <Box className="category form-control">
            <Typography className="label">Banner Image</Typography>
            <Box className="Banner_img_preview">
              <BannerImage formik={formik} edited={edited} />
              {formik.touched.image && formik.errors.image ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.image}
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>
          </Box>

          <Box className="category form-control">
            <Box className="category_field">
              <Typography className="label">Category</Typography>
              <CustomTextarea
                select
                variant="outlined"
                name="category"
                value={formik.values.category}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value="default">Select an Category</MenuItem>
                {bannersCategories.loading ? (
                  <CircularProgress sx={{ color: "#ef364e" }} />
                ) : bannersCategories.data?.data?.length > 0 ? (
                  bannersCategories.data.data.map((category) => (
                    <MenuItem value={category.id}>{category.name}</MenuItem>
                  ))
                ) : (
                  bannersCategories.error
                )}
              </CustomTextarea>
              {formik.touched.category && formik.errors.category ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.category}
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>
          </Box>

          {formik.values.category == 6 ? (
            <Box className="category form-control">
              <Box className="category_field">
                <Typography className="label">
                  Select Previous Months
                </Typography>
                <CustomTextarea
                  select
                  variant="outlined"
                  name="previous_months"
                  value={formik.values.previous_months}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <MenuItem value="default">Select Months</MenuItem>
                  {Array.from({ length: 2 }).map((_, i) => (
                    <MenuItem
                      value={moment().subtract(i, "months").format("YYYY-MM")}
                    >
                      {moment().subtract(i, "months").format("MMM-YYYY")}
                    </MenuItem>
                  ))}
                </CustomTextarea>
                {formik.touched.previous_months &&
                formik.errors.previous_months ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {formik.errors.previous_months}
                  </FormHelperText>
                ) : (
                  ""
                )}
              </Box>
            </Box>
          ) : (
            ""
          )}

          {
            // formik.values.category !== 7 ||
            // formik.values.category !== 8 ||
            // formik.values.category !== 9 ||
            // formik.values.category !== ""
            ![7, 8, "default"].includes(formik.values.category) ? (
              <Box className="category form-control">
                <Box className="category_field">
                  <Typography className="label">Type</Typography>
                  <FormControl>
                    <RadioGroup
                      defaultValue="monthly"
                      name="type"
                      value={formik.values.type}
                      onChange={formik.handleChange}
                    >
                      <FormControlLabel
                        value="monthly"
                        control={
                          <Radio
                            sx={{
                              "&.Mui-checked": {
                                color: "#ef364e",
                              },
                            }}
                          />
                        }
                        label="Monthly"
                      />
                      <FormControlLabel
                        value="seasons"
                        control={
                          <Radio
                            sx={{
                              "&.Mui-checked": {
                                color: "#ef364e",
                              },
                            }}
                          />
                        }
                        label="Seasons"
                      />
                    </RadioGroup>
                  </FormControl>
                  {formik.touched.type && formik.errors.type ? (
                    <FormHelperText sx={{ color: "red" }}>
                      {formik.errors.type}
                    </FormHelperText>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
            ) : (
              ""
            )
          }

          <Box className="category form-control">
            <Button className="pt-create" type="submit">
              {edited ? "Update" : "Create"}
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default BannerForm;
